import { render, staticRenderFns } from "./MyAccreditationEventsMobileCard.vue?vue&type=template&id=dd3c43b4&scoped=true"
import script from "./MyAccreditationEventsMobileCard.vue?vue&type=script&lang=js"
export * from "./MyAccreditationEventsMobileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3c43b4",
  null
  
)

export default component.exports